import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './config/auth';
import { App } from './App';
import './index.css';

const msalInstance = new PublicClientApplication(msalConfig);

// Attempt silent SSO on startup (reuses existing Azure AD session)
msalInstance.initialize().then(() => {
  msalInstance.handleRedirectPromise().catch((err) => {
    console.warn('[MSAL] Redirect handling failed:', err);
  }).then(() => {
    if (msalInstance.getAllAccounts().length === 0) {
      msalInstance.ssoSilent({ scopes: ['openid', 'profile', 'email'] }).catch(() => {
        // No existing session — user will need to click sign in
      });
    }
  });
});

const isAuthBypassed = import.meta.env.VITE_AUTH_BYPASS === 'true';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {isAuthBypassed ? (
      <App />
    ) : (
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    )}
  </StrictMode>
);
